import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import SeoHelmet from "../components/SeoHelmet";

const NewsPageMobile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const today = new Date().toISOString().split("T")[0];
        const response = await api.get(`/api/events/public-by-date?date=${today}`);
        setEvents(response.data);
      } catch (err) {
        console.error("Erreur chargement événements:", err);
      }
    };
    fetchEvents();
  }, []);

  return (
  	<>	
      <SeoHelmet
        page="news"
        canonical="https://eventbycar.com/actualites"
        values={{
          title: t("news.today_events"),
          description: t("news.meta_description")
        }}
      />
      <div className="p-4 space-y-6">
        <h1 className="text-xl font-bold text-center mb-4">{t("news.today_events")}</h1>
  
        {events.length === 0 ? (
          <p className="text-center text-gray-500">{t("news.no_event_today")}</p>
        ) : (
          events.map((event) => (
            <div
              key={event.id}
              className="bg-white rounded-xl shadow hover:shadow-md transition overflow-hidden cursor-pointer"
              onClick={() => navigate(`/event/user/${event.id_user}`)}
            >
              {event.logo && (
                <img
                  src={event.logo}
                  alt="logo"
                  className="w-full h-40 object-cover"
                />
              )}
              <div className="p-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-1 truncate">
                  {event.title}
                </h2>
                <p className="text-gray-600 text-sm">📍 {event.location}</p>
                <p className="text-gray-500 text-sm">📅 {" "}{event.date
                    ? new Date(event.date).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      }) +
                      (event.time ? ` - ${event.time.slice(0, 5)}` : "")
                    : t("news.no_date")}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
	</>
  );
};

export default NewsPageMobile;
